import { useEffect } from 'react';

const preloadCache = new Map();

export function preloadImages(urls) {
  for (const url of urls) {
    if (preloadCache.has(url)) continue;
    const img = new window.Image();
    img.src = url;
    preloadCache.set(url, img);
  }
}

export function useImagePreloader(urls) {
  useEffect(() => {
    preloadImages(urls);
  }, [urls]);
}